// extracted by mini-css-extract-plugin
export default {"passwordButtonWrapper":"EditUserNameModal_passwordButtonWrapper__H0TOy"};